/**
 * ArchiveLiftSize is an object that manages the dynamic class assignment
 * based on the number of child elements in the `.post-lifts` element.
 * @namespace ArchiveLiftSize
 */
const ArchiveLiftSize = {
  // Get the necessary elements.
  postLifts: document.querySelector(".post-lifts"),
  postsSection: document.querySelector("#dynamic-archive-posts"),

  /**
   * Initializes the MutationObserver to observe changes in the `postLifts` element.
   * @method
   */
  init: function () {
    if (this.postLifts) {
      new MutationObserver(this.callback.bind(this)).observe(this.postLifts, {
        childList: true,
      });
    }
  },

  /**
   * Callback function for the MutationObserver. It calculates the number of child elements
   * in `postLifts` and calls the `setPostLiftsClass` method with this number.
   * @method
   * @param {MutationRecord[]} mutationList - List of MutationRecord objects representing the changes.
   */
  callback: function (mutationList) {
    const postCount =
      mutationList[mutationList.length - 1].target.childElementCount;
    this.setPostLiftsClass(postCount);
  },

  /**
   * Sets the class of `postsSection` based on the number of child elements in `postLifts`.
   * @method
   * @param {number} amount - The number of child elements in `postLifts`.
   */
  setPostLiftsClass: function (amount) {
    this.postsSection.classList.remove("one", "two", "three", "four");
    this.postsSection.classList.add(
      ["one", "two", "three", "four"][(amount % 4) - 1],
    );

    if (amount % 4 === 1) {
      this.createWrapper();
    }
  },

  /**
   * Creates a wrapper for the post information elements.
   * @method
   */
  createWrapper: function () {
    const wrapper = document.createElement("div");
    wrapper.className = "post-info";

    const dataElement = document.querySelector(".tease-nr-0 .data");

    dataElement.parentNode.insertBefore(wrapper, dataElement);

    ["data", "post-title", "preview", "teaselink"].forEach((className) => {
      const element = document.querySelector(`.tease-nr-0 .${className}`);
      wrapper.appendChild(element);
    });
  },
};

// Initialize the ArchiveLiftSize object
ArchiveLiftSize.init();
